import { ScopedElementsMixin } from '@open-wc/scoped-elements';
export function ScopedElements(Class) {
    return ScopedElementsMixin(Class);
}
